/**
 *
 */

class LibCore {

    constructor() {

        $(() => {

            // Document ready calls
            $(this).trigger('before.document.ready');
            $(this).trigger('document.ready');
            $(this).trigger('after.document.ready');

            // Window resize debounce
            $(window).on('resize', () => {
                this.onResize.apply(this);
            });

            // On orientation change
            $(window).on('orientationchange', () => {
                let orientation;
                switch (window.orientation) {
                    case -90:
                    case 90:
                        orientation = 'landscape';
                        break;
                    default:
                        orientation = 'portrait';
                        break;
                }

                this.onOrientationChange(orientation);
            });
        });

        // Window load event
        $(window).on('load', () => {
            $(this).trigger('window.load');
        });
    }

    onOrientationChange(orientation) {
        $(this).trigger('orientation.change', [orientation]);
    }

    onResize() {
        Lib.Debounce(() => {
            $(this).trigger('window.resize.end');
        }, 200);
    }

    bindModules(parent_) {

        let parent = typeof parent_ === 'undefined' ? $('body') : parent_;

        // Attach toggles in the modal
        let toggles = parent.find('[data-toggle]');
        if (toggles.length !== 0) {
            Lib.Toggle.bindToggles(toggles);
        }

        // Attach datepickers in the modal
        let datepickers = parent.find('input[data-datepicker-options]');
        if (datepickers.length !== 0) {
            $('input[data-datepicker-options]:focus').blur();
            Lib.Datepicker.initializeDatepickers(datepickers);
        }

        // Attach fileuploads in the modal
        let uploads = parent.find('.dropzone');
        if (uploads.length !== 0) {
            Lib.Upload.initializeDropzones(uploads);
        }
        // Attach wysiwyg in the modal
        let wysiwyg = parent.find('textarea[data-wysiwyg]');
        if (wysiwyg.length !== 0) {
            Lib.Wysiwyg.bindEditor(wysiwyg);
        }

        // Attach autosizes in the modal
        let textareas = parent.find('textarea[data-autosize]:not([data-wysiwyg])');
        if (textareas.length !== 0) {
            Lib.Textarea.enableAutosize(textareas);
        }

        // Attach decimals in the modal
        let decimalFields = parent.find('input[type="text"][data-decimal]');
        if (decimalFields.length !== 0) {
            Lib.InputMask.bindDecimal(decimalFields);
        }

        // Attach counters in the modal
        let textareasCounter = parent.find('textarea[data-counter]:not([data-wysiwyg])');
        if (textareasCounter.length !== 0) {
            Lib.Textarea.enableCounter(textareasCounter);
        }

        // Bind tooltips
        Lib.Tooltip.bindTooltips(parent.find('[data-tooltip]'));

        // Reattach ripples for buttons inside the modal
        Lib.Animation.ripple();

        Lib.Form.makeReadonlySelects(parent.find('select[readonly]'));

    }
}

let options = window.Lib.options || {};
const Lib = new LibCore;
window.Lib = Lib;
window.Lib.options = options;

